import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/becoming-wind-v2/becoming-wind-v2/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/becoming-wind-v2/becoming-wind-v2/src/components/Navbar.tsx");
